module.exports = __webpack_public_path__ + "static/PP7-b7190b3be8c730e0185c6a96f261d155.jpg";